import React from 'react'
import { Redirect, Route, Switch, useLocation, useParams } from 'react-router'
import { HoverVisibleNotification, SectionTabsLinks } from '@Root/components'
import { helperTextHESAPreHESAChecksTabLinks } from '@Root/configs'
import styles from './styles.module.scss'
import { TableReports } from './TableReports'

const description = {
  'Report #1 - Student Load': 'Student mode is set to Part-time and the Ref Period Student Load is greater than 80',
  'Report #2 - Left Last Provider': 'A Year left past provider record exists, when it shouldn’t',
}

export const Manager = () => {
  const location = useLocation()
  const pathname = location.pathname
  const { tabId: currentTabLabel } = useParams()
  const currentSlugTab = pathname.split('/')[4]
  const currentSubSlug = pathname.split('/')[5]
  const currentLinks = helperTextHESAPreHESAChecksTabLinks[currentTabLabel]
  const currentSlugTabObj = currentLinks.find(tab => tab.path === currentSlugTab)

  return (
    <div style={{ marginTop: 190 }} className={styles.wrapper}>
      <SectionTabsLinks tabs={currentLinks} defaultUrl={`/home/pre-hesa-checks/${currentTabLabel}`} />
      <div className={styles.options}>
        <HoverVisibleNotification title={currentSlugTabObj?.name} initialTop={'-100%'}>
          <div>
            <ui>
              <li>{description[currentSlugTabObj?.name]}</li>
            </ui>
          </div>
        </HoverVisibleNotification>

        <Switch>
          {currentLinks
            .filter(link => !link.hideInTableManager)
            .map(link =>
              link.subLinks ? (
                link.subLinks.map(subLink => {
                  return (
                    <Route
                      path={`/home/pre-hesa-checks/${currentTabLabel}/${link.path}/${subLink.path}`}
                      exact
                      render={() => <TableReports />}
                      key={subLink.name}
                    />
                  )
                })
              ) : (
                <Route path={`/home/pre-hesa-checks/${currentTabLabel}/${link.path}`} exact render={() => <TableReports />} key={link.name} />
              )
            )}
          {!currentSlugTab && (
            <Redirect from={`/home/pre-hesa-checks/${currentTabLabel}`} to={`/home/pre-hesa-checks/${currentTabLabel}/${currentLinks[0].path}`} />
          )}
          {currentSlugTab && currentSlugTabObj?.subLinks?.length > 0 && !currentSubSlug && (
            <Redirect
              from={`/home/pre-hesa-checks/${currentTabLabel}/${currentSlugTabObj.path}`}
              to={`/home/pre-hesa-checks/${currentTabLabel}/${currentSlugTabObj.path}/${currentSlugTabObj.subLinks[0].path}`}
            />
          )}
        </Switch>
      </div>
    </div>
  )
}
